(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["solocaffe-marcas-carrusel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-brand-carousel')) {
    customElements.define('sc-brand-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const track = this.querySelector('.sc-brands__track');
        const slides = [...track.children];
        const position = this.querySelector('.sc-brands__position');
        const play = this.querySelector('[data-play]');
        this.paused = false;
        this.visible = false;
        this.pointerInside = false;
        this.touching = false;
        const go = direction => {
          if (!track.clientWidth || slides.length < 2) return;
          const current = Math.round(track.scrollLeft / track.clientWidth);
          const next = (current + direction + slides.length) % slides.length;
          track.scrollTo({ left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        const schedule = () => {
          clearTimeout(this.timer);
          if (this.paused || !this.visible || document.hidden || this.pointerInside || this.touching || this.contains(document.activeElement) || slides.length < 2) return;
          this.timer = setTimeout(() => { go(1); schedule(); }, 6000);
        };
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => { go(Number(button.dataset.direction)); schedule(); }, { signal }));
        play?.addEventListener('click', () => {
          this.paused = !this.paused;
          play.setAttribute('aria-pressed', String(this.paused));
          play.setAttribute('aria-label', this.paused ? play.dataset.resumeLabel : play.dataset.pauseLabel);
          play.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
          schedule();
        }, { signal });
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.pointerInside = true; schedule(); } }, { signal });
        this.addEventListener('pointerleave', () => { this.pointerInside = false; schedule(); }, { signal });
        this.addEventListener('pointerdown', () => { this.touching = true; schedule(); }, { signal });
        window.addEventListener('pointerup', () => { this.touching = false; schedule(); }, { signal });
        window.addEventListener('pointercancel', () => { this.touching = false; schedule(); }, { signal });
        this.addEventListener('focusin', schedule, { signal });
        this.addEventListener('focusout', () => queueMicrotask(schedule), { signal });
        document.addEventListener('visibilitychange', schedule, { signal });
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; schedule(); }, { threshold: 0.15 });
        this.observer.observe(this);
        track.addEventListener('scroll', () => {
          if (position) position.textContent = `${Math.round(track.scrollLeft / track.clientWidth) + 1} / ${slides.length}`;
        }, { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            go(event.key === 'ArrowRight' ? 1 : -1);
            schedule();
          }
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const selected = slides.findIndex(slide => slide.contains(event.target));
          if (selected >= 0) track.scrollTo({ left: selected * track.clientWidth, behavior: 'instant' });
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
